type MessageEventLike = {
  data?: unknown;
};

type MessagePortLike = {
  onmessage: ((event: MessageEventLike) => void) | null;
  postMessage: (data?: unknown) => void;
  close: () => void;
  start: () => void;
};

class FallbackMessagePort implements MessagePortLike {
  onmessage: ((event: MessageEventLike) => void) | null = null;

  private target: FallbackMessagePort | null = null;

  private closed = false;

  setTarget(target: FallbackMessagePort) {
    this.target = target;
  }

  postMessage(data?: unknown) {
    if (this.closed || !this.target || this.target.closed) {
      return;
    }

    setTimeout(() => {
      this.target?.onmessage?.({ data });
    }, 0);
  }

  close() {
    this.closed = true;
  }

  start() {}
}

class FallbackMessageChannel {
  port1: FallbackMessagePort;

  port2: FallbackMessagePort;

  constructor() {
    this.port1 = new FallbackMessagePort();
    this.port2 = new FallbackMessagePort();

    this.port1.setTarget(this.port2);
    this.port2.setTarget(this.port1);
  }
}

export function ensureMessageChannel() {
  if (typeof globalThis === 'undefined') {
    return;
  }

  if (typeof globalThis.MessageChannel !== 'undefined') {
    return;
  }

  (globalThis as any).MessageChannel = FallbackMessageChannel;
}
